import { render, staticRenderFns } from "./TareaTicketComponent.vue?vue&type=template&id=1f3f6c52&"
import script from "./TareaTicketComponent.vue?vue&type=script&lang=js&"
export * from "./TareaTicketComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports